export const setConfigType = (category) => {
    let type = '';
    if (category) {
        switch(category) {
            case 'CAPACITY':
            case 'EXPERIMENT_VARIANT_WEIGHT':
                type = 'INT';
                break;
            case 'AFFILIATE_KEY_LIST':
            case 'TRAFFIC_SOURCE_ID_LIST':
            case 'STATE_LIST':
            case 'REFERRING_SITE_URL_LIST':
            case 'FIELD_VALUE_LIST':
            case 'VEHICLE_MAKE_LIST':
            case 'VEHICLE_MODEL_LIST':
                type = 'LIST_STRING';
                break;
            case 'TRAFFIC_SOURCE_ID_SUBCODE_LIST':
            case 'AFFILIATE_KEY_SUBCODE_LIST':
            case 'TRAFFIC_SOURCE_ID_SUBCODE_HASH_LIST':
            case 'AFFILIATE_KEY_SUBCODE_HASH_LIST':
            case 'AFFILIATE_KEY_FIELD_VALUE_LIST':
            case 'TRAFFIC_SOURCE_ID_FIELD_VALUE_LIST':
            case 'TRAFFIC_SOURCE_ID_REFERRING_SITE_URL_LIST':
            case 'AFFILIATE_KEY_REFERRING_SITE_URL_LIST':
                type = 'LIST_PAIR_STRING';
                break;
            case 'PRICE_POINT':
                type = 'DECIMAL';
                break;
            case 'FEATURE_ENABLED':
                type = 'BOOL';
                break;
            case 'EVERFLOW_OFFER_LIST':
                type = 'LIST_INT';
                break;
            case 'STRING_VALUE':
                type = 'STRING';
                break;
            default:
                type = 'JSON';
                break;
        }
    }

    return type;
};

export const setConfigValueKey = (category, type) => {
    let key;
    switch (type) {
        case 'BOOL':
            key = 'valueBool';
            break;
        case 'STRING':
            key = 'valueString';
            break;
        case 'LIST_INT':
            key = 'valueIntArray';
            break;
        case 'LIST_STRING':
            key = 'valueStringArray';
            break;
        case 'LIST_PAIR_STRING':
            key = 'valuePairStringStringArray';
            break;
        case 'JSON':
            if (category === 'SCHEDULE') {
                key = 'valueCampaignSchedule';
            } else {
                key = 'valueCampaignCapacity';
            }
            break;
        case 'DECIMAL':
            key = 'valueDecimal';
            break;
        default:
            key = 'valueInt';
            break;
    }

    return key;
};

export const isPairCategory = (configCategory) => {
    if (configCategory.includes('_SUBCODE_LIST')) {
        return true
    }
    if (configCategory.includes('_SUBCODE_HASH_LIST')) {
        return true
    }
    if (configCategory.includes('_FIELD_VALUE_LIST')) {
        return true
    }
    if (configCategory.includes('_REFERRING_SITE_URL_LIST')) {
        return true
    }
    return false
}
